"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var EcommerceStoreStats =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(EcommerceStoreStats, _Record);

  function EcommerceStoreStats() {
    (0, _classCallCheck2.default)(this, EcommerceStoreStats);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EcommerceStoreStats).apply(this, arguments));
  }

  return EcommerceStoreStats;
}((0, _immutable.Record)({
  contactsCount: 0,
  dealsCount: 0,
  productsCount: 0
}));

exports.default = EcommerceStoreStats;
module.exports = exports.default;